<template>
  <div class="app-container">
    <el-tabs v-model="activeName">
      <el-tab-pane label="月度" name="yuedu">
        <yuedu v-if="activeName==='yuedu'"></yuedu>
      </el-tab-pane>
      <el-tab-pane label="季度" name="jidu">
        <jidu v-if="activeName==='jidu'"></jidu>
      </el-tab-pane>
      <el-tab-pane label="半年度" name="banniandu">
        <banniandu v-if="activeName==='banniandu'"></banniandu>
      </el-tab-pane>
      <el-tab-pane label="年度" name="niandu">
        <niandu v-if="activeName==='niandu'"></niandu>
      </el-tab-pane>
      <!-- <el-tab-pane label="汇总" name="huizong">
        <huizong v-if="activeName==='huizong'"></huizong>
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>
<script>
import yuedu from './yuedu.vue'
import jidu from './jidu.vue'
import banniandu from './banniandu.vue'
import niandu from './niandu.vue'
import huizong from './huizong.vue'
export default {
  components: {
    yuedu,
    jidu,
    banniandu,
    niandu,
    huizong
  },
  data () {
    return {
      activeName: 'yuedu'
    }
  }
}
</script>
<style scoped lang='less'>
/deep/ .el-tabs {
  height: 100%;
  display: flex;
  flex-direction: column;
}
/deep/ .el-tabs__header {
  margin: 0;
  flex-shrink: 0;
}
/deep/ .el-tabs__content {
  flex: 1;
  overflow: hidden;
}
/deep/ .el-tab-pane {
  height: 100%;
}
</style>
